module.exports = __webpack_public_path__ + "static/assets/d4c001a5348e8e71237438ccd8b4cd9f.png";